import React, { useEffect } from 'react';
import { useCustomerPublic } from '../../hooks/useCustomerPublic';

interface EntryFormHeaderProps {
    currentStep: number;
}

const totalSteps = 5;

const EntryFormHeader: React.FC<EntryFormHeaderProps> = ({currentStep}) => {
    const { customerData } = useCustomerPublic();

    // Calculate progress width but cap it to ensure it doesn't extend beyond the right boundary
    const progressWidth = Math.min(((currentStep - 1) / (totalSteps - 1)) * 100, 100);

    // Use customer data or fallback to default
    const displayTitle = customerData?.formPageTitle || '';

    // Update document title when customer data is loaded
    useEffect(() => {
        if (customerData?.formPageTitle) {
            document.title = customerData.formPageTitle;
        }
    }, [customerData]);

    return (
        <>
            <header className="header">
                <div className="header-container">
                    <div className="company-name">{displayTitle}</div>
                </div>
            </header>

            <div className="progress-container">
                <div className="progress-steps">
                    <div className="progress-bar" style={{width: `${progressWidth}%`}} id="progressBar"></div>
                    <div className={`progress-step ${currentStep === 1 ? 'active' : 'completed'}`}>
                        <div className="step-number">1</div>
                        <div className="step-label">情報入力</div>
                    </div>
                    <div className={`progress-step ${currentStep === 2 ? 'active' : currentStep > 2 ? 'completed' : ''}`}>
                        <div className="step-number">2</div>
                        <div className="step-label">入力確認</div>
                    </div>
                    <div className={`progress-step ${currentStep === 3 ? 'active' : currentStep > 3 ? 'completed' : ''}`}>
                        <div className="step-number">3</div>
                        <div className="step-label">手順説明</div>
                    </div>
                    <div className={`progress-step ${currentStep === 4 ? 'active' : currentStep > 4 ? 'completed' : ''}`}>
                        <div className="step-number">4</div>
                        <div className="step-label">本人確認</div>
                    </div>
                    <div className={`progress-step ${currentStep === 5 ? 'active' : currentStep > 5 ? 'completed' : ''}`}>
                        <div className="step-number">5</div>
                        <div className="step-label">完了</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EntryFormHeader;
